import React from 'react';
import PropTypes from 'prop-types';
import './RTRBookReaderContent.scss';
import SvgIcon from '../../../SvgIcon';
import BookTags from '../../../Book/components/BookTags';
import DisclaimerBox from '../../../DisclaimerBox';

const RTRBookClosingPage = ({
    isRightToLeftDirection,
    t,
    bookData,
    online,
    book,
}) => {
    return (
        <div
            className="bookReaderPageWrapper"
            style={{ height: '80vh', width: '99%', marginLeft: '1%' }}
        >
            <div className="RightBookPage closingPage">
                <div className="closingPageHeader">
                    <div className="RTRLogo" style={{ margin: '0.5rem auto' }}>
                        {' '}
                        <SvgIcon name={'rtr-logo'} size="rtr-logo" />
                    </div>
                </div>
                <div className="closingPageContent">
                    <BookTags
                        tags={book.tags}
                        online={online}
                        t={t}
                        type={'storyReaderFinalPage'}
                    />
                    <div className="closingPageContentData">
                        <div
                            className={
                                isRightToLeftDirection
                                    ? 'closingPageContentDataTitle-Rtl'
                                    : 'closingPageContentDataTitle'
                            }
                        >
                            {t('book.storyFinalPageContentTitle')}
                        </div>
                        <div
                            className={
                                isRightToLeftDirection
                                    ? 'closingPageContentDataPara1-Rtl'
                                    : 'closingPageContentDataPara1'
                            }
                        >
                            {t('book.storyFinalPageContentPara1')}
                        </div>
                    </div>
                    {bookData.copy_right_holder &&
                        bookData.copy_right_holder.org_name && (
                            <div
                                style={{
                                    textAlign: isRightToLeftDirection
                                        ? 'center'
                                        : 'left',
                                    marginTop: isRightToLeftDirection ? '1rem' : '1.5rem',
                                }}
                            >
                                {t('Book.storyCopyrightStartText')}{' '}
                                <span
                                    style={{
                                        color: '#007AA4',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {bookData.copy_right_holder.org_name}
                                </span>
                                {' '}{t('Book.storyCopyrightEndText')}
                            </div>
                        )}
                </div>
                <div
                    className="closingPageFooter"
                >
                    <DisclaimerBox 
                        licenseTypeImage={bookData.license_type.image_url}
                        licenseTypeMessage={bookData.license_type.message}
                    />
                </div>
            </div>
        </div>
    );
};

RTRBookClosingPage.propTypes = {
    isRightToLeftDirection: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    bookData: PropTypes.shape({
        license_type: PropTypes.shape({
            image_url: PropTypes.string,
            message: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    online: PropTypes.bool.isRequired,
    book: PropTypes.shape({
        tags: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
};

export default RTRBookClosingPage;
